import React from 'react';
import { Result } from 'antd';
import { useLocation } from 'react-router-dom';
import usePermissions from '../../hooks/usePermissions';

const RequirePermission = ({
  section,
  path,
  fallback = null,
  children,
}) => {
  const location = useLocation();
  const { can, canPath } = usePermissions();

  const targetPath = path || location.pathname;
  const allowed = section ? can(section) : canPath(targetPath);

  if (!allowed) {
    if (fallback) {
      return fallback;
    }
    return (
      <Result
        status="403"
        title="Sin acceso"
        subTitle="No tienes permisos suficientes para ver esta sección."
      />
    );
  }

  return children;
};

export default RequirePermission;
